import React, { useEffect, useRef, useState } from "react"
import { Modal, ModalHeader, ModalBody } from "reactstrap"
import { io } from "socket.io-client"
import { axiosbaseurl } from "../../../config"

const WhatsAppQRModal = ({ isOpen, toggle }) => {
  const [qr, setQr] = useState(null)
  const [status, setStatus] = useState("loading")
  const socketRef = useRef(null)

  useEffect(() => {
    if (!isOpen) return

    setQr(null)
    setStatus("loading")

    const serverOrigin = new URL(process.env.REACT_APP_API_URL).origin
    const socket = io(serverOrigin)
    socketRef.current = socket

    axiosbaseurl.post("/whatsapp/init").catch(() => {})

    socket.on("whatsapp:qr", ({ qr: qrData }) => {
      console.log(qrData)
      console.log("abc")
      setQr(qrData)
      setStatus("scan_qr")
    })

    socket.on("whatsapp:ready", () => {
      console.log("error occureadyrd")
      setQr(null)
      setStatus("connected")
    })

    socket.on("whatsapp:disconnected", () => {
      console.log("error occurddisconnect")
      setStatus("disconnected")
    })

    socket.on("connect_error", () => {
      console.log("error occurd")
      setStatus("error")
    })

    return () => {
      socket.disconnect()
      socketRef.current = null
    }
  }, [isOpen])

  const renderContent = () => {
    switch (status) {
      case "loading":
        return (
          <div className="text-center py-4">
            <div className="spinner-border text-success" role="status" />
            <p className="mt-3 mb-0 text-muted">Connecting to WhatsApp...</p>
          </div>
        )
      case "scan_qr":
        return (
          <div className="text-center">
            <p className="text-muted mb-3">
              Open WhatsApp on your phone and scan this QR code
            </p>
            <img
              src={qr}
              alt="Scan QR Code"
              style={{ maxWidth: "260px", width: "100%", borderRadius: "8px" }}
            />
          </div>
        )
      case "connected":
        return (
          <div className="text-center py-4">
            <i
              className="bx bxl-whatsapp"
              style={{ fontSize: "48px", color: "#25D366" }}
            />
            <p className="mt-2 mb-0 fw-semibold text-success">
              WhatsApp Connected!
            </p>
          </div>
        )
      case "disconnected":
        return (
          <div className="text-center py-4">
            <i
              className="bx bx-wifi-off"
              style={{ fontSize: "40px", color: "#dc3545" }}
            />
            <p className="mt-2 mb-0 text-danger">WhatsApp Disconnected</p>
            <button
              className="btn btn-sm btn-outline-success mt-3"
              onClick={() => {
                setStatus("loading")
                axiosbaseurl.post("/whatsapp/init").catch(() => {})
              }}
            >
              Reconnect
            </button>
          </div>
        )
      case "error":
        return (
          <div className="text-center py-4">
            <i
              className="bx bx-error-circle"
              style={{ fontSize: "40px", color: "#dc3545" }}
            />
            <p className="mt-2 mb-0 text-danger">
              Unable to connect to server
            </p>
          </div>
        )
      default:
        return null
    }
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="sm">
      <ModalHeader toggle={toggle}>WhatsApp Connection</ModalHeader>
      <ModalBody>{renderContent()}</ModalBody>
    </Modal>
  )
}

export default WhatsAppQRModal
